import React from "react";
import { MenuItem, Paper } from "@mui/material";
import { styled } from "@mui/system";

const MainContainer = styled(Paper)({
  width: "250px",
  textAlign: "left",
  top: "80px",
  marginTop: "8px",
  height: "1000px",
  boxShadow: "none",
  border: "1px solid #333333",
  backgroundColor: "#1e1e1e",
  color: "#ffffff",
  position: "sticky",
  "@media (max-width: 650px)": {
    display: "none",
  },
});

const Heading = styled("p")({
  color: "#ffffff",
  fontWeight: "bold",
  fontSize: "14px",
  paddingLeft: "16px",
});

const CategoryItem = styled(MenuItem)(({ selected }) => ({
  color: selected && "#2196F3",
  fontWeight: selected && "bold",
  fontSize: "14px",
}));

/**
 *
 * @param {Function} changeCategory Changes the category selected
 * @param {Number} currentCategory Current categoryID selected
 * @param {Array} categories - All the categories available
 * @returns Category selection menu
 */
const CategorySelect = ({ changeCategory, currentCategory, categories }) => {
  const handleCategoryClick = (e) => {
    const { myValue } = e.currentTarget.dataset;
    changeCategory(parseInt(myValue));
  };

  return (
    <MainContainer>
      <Heading>Categories</Heading>
      <CategoryItem
        selected={0 === currentCategory}
        data-my-value={0}
        onClick={handleCategoryClick}
      >
        All
      </CategoryItem>
      {categories.map(({ displayName, categoryId }) => (
        <CategoryItem
          selected={categoryId === currentCategory}
          data-my-value={categoryId}
          onClick={handleCategoryClick}
        >
          {displayName}
        </CategoryItem>
      ))}
    </MainContainer>
  );
};

export default CategorySelect;
